import { render, staticRenderFns } from "./addConfig.vue?vue&type=template&id=1d8fe9bd&"
import script from "./addConfig.vue?vue&type=script&lang=js&"
export * from "./addConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d8fe9bd')) {
      api.createRecord('1d8fe9bd', component.options)
    } else {
      api.reload('1d8fe9bd', component.options)
    }
    module.hot.accept("./addConfig.vue?vue&type=template&id=1d8fe9bd&", function () {
      api.rerender('1d8fe9bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/performancecenter/theaterManage/addConfig.vue"
export default component.exports